module.exports = __webpack_public_path__ + "static/media/centralSeatPremierOne.6873b133.svg";